import _ from 'lodash';
import { FinalReportItemModel } from '../../../models/FinalReportItem';
import { resources } from '../../../resources/resources';
import { FinalReportGridItemModel, ReportFileContentTypes } from './types';

export const mapToReportGridItem = (
  item: FinalReportItemModel,
  onDelete: (reportId: number, fileContentTypeId: number) => void,
  onDownload: (item: FinalReportGridItemModel) => void,
): FinalReportGridItemModel => {
  return {
    reportId: item.reportId,
    fileCode:
      item.fileCode ?? item.invoiceCode ?? item.advanceInvoiceCode ?? '',
    fileContentTypeId: item.fileContentTypeId as ReportFileContentTypes,
    company: item.companyName,
    generatedBy:
      item.customer ?? resources.admin.finalReport.grid.defaultCustomer,
    date: item.date,
    dateAdded: item.dateAdded,
    canDownload:
      (!_.isNull(item.fileCode) && !_.isEmpty(item.fileCode)) ||
      (!_.isNull(item.invoiceCode) && !_.isEmpty(item.invoiceCode)) ||
      (!_.isNull(item.advanceInvoiceCode) &&
        !_.isEmpty(item.advanceInvoiceCode)),
    canDelete: !item.approved,
    isDownloading: false,
    isDeleting: false,
    onDownload,
    onDelete,
  };
};
